import { useCallback } from 'react';
import { useCRUD } from '@/hooks/queries/useCRUD';

interface UseDetailSelectionOptions<TData extends { uuid: string }> {
  endpoint: string;
  onSelect: (row: TData | null) => void;
}

export const useDetailSelection = <TData extends { uuid: string }>({
  endpoint,
  onSelect
}: UseDetailSelectionOptions<TData>) => {
  const { fetchDetail } = useCRUD<TData>({
    endpoint,
    initialFetch: false
  });

  return useCallback(
    async (row: TData | null) => {
      onSelect(row);

      if (!row?.uuid) {
        return;
      }

      const data = await fetchDetail(row.uuid);
      onSelect(Array.isArray(data) || !data ? row : data);
    },
    [fetchDetail, onSelect]
  );
};
